import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditRadioInput } from './edit';
import { PreviewRadioInput } from './preview';
import { ViewRadioInput } from './view';

export const RadioInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	if (renderMode === FormRenderMode.EDIT) {
		return (
			<EditRadioInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	if (renderMode === FormRenderMode.PREVIEW) {
		return (
			<PreviewRadioInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	return (
		<ViewRadioInput
			fieldId={fieldId}
			fieldInputId={fieldInputId}
			fieldLabelId={fieldLabelId}
			fieldErrorId={fieldErrorId}
		/>
	);
};
